export type ProfileEntity = {
  id?: string | null;
  slug?: string | null;
};

export function getOrganizationProfilePath(
  org: ProfileEntity | null | undefined,
): string | null {
  if (!org?.slug && !org?.id) return null;
  if (org.slug) return `/web/org/${org.slug}`;
  return `/web/profile/organization/${org.id}`;
}

export function getUserProfilePath(
  user: ProfileEntity | null | undefined,
): string | null {
  if (!user?.slug && !user?.id) return null;
  if (user.slug) return `/web/user/${user.slug}`;
  return `/web/profile/user/${user.id}`;
}

export function getCreatorProfilePath(
  entity: string | null | undefined,
  organization: ProfileEntity | null | undefined,
  user: ProfileEntity | null | undefined,
): string | null {
  if (entity === 'Organization' && organization) {
    return getOrganizationProfilePath(organization);
  }
  if (entity === 'User' && user) {
    return getUserProfilePath(user);
  }
  if (organization?.id || organization?.slug) {
    return getOrganizationProfilePath(organization);
  }
  if (user?.id || user?.slug) {
    return getUserProfilePath(user);
  }
  return null;
}
